import React, {useState} from 'react';
import {View, StyleSheet, Image} from 'react-native';
import {Text, Dialog, Button, Portal} from 'react-native-paper';
import {DrawerContentScrollView, DrawerItemList, DrawerItem} from '@react-navigation/drawer';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';

import {useTranslation} from 'react-i18next';
import {useAuthStore} from '../store/useAuthStore';
import {colors, spacing} from '../theme';

const CustomDrawerContent = props => {
  const user = useAuthStore(state => state.user);
  const logout = useAuthStore(state => state.logout);
  const {t} = useTranslation();
  const [logoutVisible, setLogoutVisible] = useState(false);

  const handleLogout = async () => {
    setLogoutVisible(false);
    await logout();
  };

  return (
    <View style={styles.wrapper}>
      <DrawerContentScrollView {...props} contentContainerStyle={styles.scrollContent}>
        <View style={styles.header}>
          <Image source={require('../assets/logo.png')} style={{width: 40, height: 40, borderRadius: 8}} />
          <Text style={styles.appName}>FabTailor</Text>
          {user?.fullName ? (
            <Text style={styles.userName}>{user.fullName}</Text>
          ) : null}
        </View>
        <DrawerItemList {...props} />
      </DrawerContentScrollView>
      <View style={styles.logoutContainer}>
        <DrawerItem
          label={t('settings.logout')}
          icon={({size}) => (
            <MaterialCommunityIcons name="logout" size={size} color={colors.error} />
          )}
          labelStyle={styles.logoutLabel}
          onPress={() => setLogoutVisible(true)}
        />
      </View>
      <Portal>
        <Dialog visible={logoutVisible} onDismiss={() => setLogoutVisible(false)} style={{borderRadius: 15}}>
          <Dialog.Title>{t('settings.logout')}</Dialog.Title>
          <Dialog.Content>
            <Text>{t('settings.confirmLogout')}</Text>
          </Dialog.Content>
          <Dialog.Actions>
            <Button onPress={() => setLogoutVisible(false)}>{t('common.cancel')}</Button>
            <Button onPress={handleLogout} textColor={colors.error}>{t('settings.logout')}</Button>
          </Dialog.Actions>
        </Dialog>
      </Portal>
    </View>
  );
};

const styles = StyleSheet.create({
  wrapper: {flex: 1},
  scrollContent: {},
  logoutContainer: {
    borderTopWidth: 1,
    borderTopColor: colors.divider,
  },
  logoutLabel: {color: colors.error},
  header: {
    backgroundColor: colors.primary,
    paddingHorizontal: spacing.lg,
    paddingTop: spacing.xxl,
    paddingBottom: spacing.lg,
    marginBottom: spacing.xs,
  },
  appName: {
    color: colors.white,
    fontSize: 20,
    fontWeight: 'bold',
    marginTop: spacing.sm,
  },
  userName: {
    color: colors.white,
    fontSize: 14,
    opacity: 0.8,
    marginTop: spacing.xs,
  },
});

export default CustomDrawerContent;
